// Slice del carrito
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  carritos: [], // Lista de carritos activos del usuario
  infoCarrito: null,
  purchaseResult: null, // Resultado de la compra
  failureCarrito: false,
  errorCarrito: null,
  isLoadingCarrito: false,
};

const carritoSlice = createSlice({
  name: "carrito",
  initialState,
  reducers: {
    setCarritos: (state, action) => {
      state.carritos = action.payload;
      state.failureCarrito = false;
      state.isLoadingCarrito = false;
    },
    carritoSuccess: (state, action) => {
      state.infoCarrito = action.payload.infoCarrito;
      state.failureCarrito = false;
      state.isLoadingCarrito = false;
    },
    carritoFailure: (state, action) => {
      state.failureCarrito = true;
      state.isLoadingCarrito = false;
      state.errorCarrito = action.payload; // mensaje de errorCarrito
    },
    carritoReset: (state) => {
      state.carritos = [];
      state.infoCarrito = null;
      state.failureCarrito = false;
      state.errorCarrito = null;
      state.isLoadingCarrito = false;
    },
    setLoadingCarrito: (state, action) => {
      state.isLoadingCarrito = action.payload;
    },
    updateCarritoInList: (state, action) => {
      const index = state.carritos.findIndex(c => c.eventoId === action.payload.eventoId);
      if (index !== -1) {
        state.carritos[index] = action.payload;
      }
    },
    removeCarritoFromList: (state, action) => {
      state.carritos = state.carritos.filter(c => c.eventoId !== action.payload);
    },
    setPurchaseResult: (state, action) => {
      state.purchaseResult = action.payload;
      state.failureCarrito = false;
      state.isLoadingCarrito = false;
    },
    resetPurchaseResult: (state) => {
      state.purchaseResult = null;
    },
  },
});


export const {
  setCarritos,
  carritoSuccess,
  carritoFailure,
  carritoReset,
  setLoadingCarrito,
  updateCarritoInList,
  removeCarritoFromList,
  setPurchaseResult,
  resetPurchaseResult,
} = carritoSlice.actions;
export default carritoSlice.reducer;